import "../../css/HomePage.css"
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import GameBox from "./GameBox";
import EmptyGameBox from "./EmptyGameBox";

const GameInformative = ({userGamesData, userData, gameData, handleBackClick}) => {
  const navigate = useNavigate();

    const [missingTypes, setMissingTypes] = useState([]);
    const gameTypes = ["jumper", "runner", "invader", "platformer"];

    useEffect(()=>{
        if(userGamesData === null || userGamesData === undefined)
            return;
        const missing = userGamesData
        ? gameTypes.filter((type) => 
            !userGamesData.some((g) => g.gameType === type)
            )
        : [];

        setMissingTypes(missing);
    },[userGamesData])

    const handleInfoClick = () => {
        // opens in a new tab/window
        window.open("https://www.facebook.com/gametory.th", "_blank", "noopener,noreferrer");
    };

    const handleBookingClick = () => {
        // opens in a new tab/window
        window.open("https://lin.ee/uNosyZb", "_blank", "noopener,noreferrer");
    };

    const handleBoxClick = (playId) =>{
        window.location.href = window.location.origin + "/gameroom?gameId=" + playId;
    }

    const handleEmptyClick = (type) =>{
        window.open("https://lin.ee/uNosyZb", "_blank", "noopener,noreferrer");
    }

    const handlePopupClick = (url) =>{
        window.open(url, "_blank", "noopener,noreferrer");
    }

    return (
        <div style={{display:"flex", flexDirection:"column", margin:"25px 0px 0px 0px"}}>
            <div style={{display: "flex", flexDirection:"column", alignItems:"center", width:"100%"}}>
                <div style={{
                    fontSize:"3em",
                    color:"white", 
                    fontWeight:"100", 
                    textAlign:"center", 
                    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.43)", 
                    lineHeight:"0.8em",
                    marginBottom:"5px",
                    maxWidth:"90%"
                }}>MAKE YOUR OWN GAME?</div>
                <div style={{padding:"0px 50px", display:"flex", flexDirection:"row", justifyContent:"center", alignContent:"center"}}>
                    <div 
                        style={{position:"relative", height:"15dvh", display:"flex", alignItems:"center", justifyContent:"center", margin:"0px 5px", cursor:"pointer"}}
                        onClick={handleInfoClick} 
                    >
                        <img 
                            src="/assets/icon/orange_circle_button.png"
                            style={{height:"13.5dvh", maxWidth:"90%", margin:"5px 15px", objectFit:"contain"}}
                        />
                        <div style={{position:"absolute", fontSize:"2em", color:"white", transform:"translate(-55%,-65%)", top:"50%", left:"50%", whiteSpace:"nowrap", pointerEvents:"none"}}>INFO</div>
                    </div>
                    <div 
                        style={{position:"relative", height:"15dvh", display:"flex", alignItems:"center", justifyContent:"center",  margin:"0px 5px",  cursor:"pointer", }} 
                        onClick={handleBookingClick}
                    >
                        <img 
                            src="/assets/icon/blue_rec_button.png"
                            style={{height:"12dvh", maxWidth:"90%", margin:"5px 15px", objectFit:"contain"}} 
                        />
                        <div style={{position:"absolute", fontSize:"1.8em", color:"white", transform:"translate(-55%,-65%)", top:"50%", left:"55%", whiteSpace:"nowrap", textAlign:"center"}}>
                            <div style={{marginBottom:"-5px", fontSize:"1.2em", pointerEvents:"none"}}>BOOK NOW!</div>
                            <div style={{fontSize:"0.4em", pointerEvents:"none"}}>{"(LINE OFFICIAL ACCOUNT)"}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{marginTop:"50px"}}>
                <div style={{display: "flex", flexDirection:"column", alignItems:"center", margin:"40px, 0px, 0px, 0px"}}>
                    {(userData !== null && userData !== undefined) &&
                    <div style={{
                            fontSize:"3em",
                            color:"white", 
                            fontWeight:"100", 
                            textAlign:"center", 
                            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.43)", 
                            lineHeight:"0.8em",
                            marginBottom:"5px",
                            maxWidth:"80%"
                            }}>  MORE GAMES FROM{" "}
                        <span style={{ textDecoration: "underline" }}>
                            {userData.userName.toUpperCase()}
                        </span>
                    </div>}
                </div>
                <div style={{display:"flex", flexDirection:"row", flexWrap:"wrap", justifyContent:"center", }}>
                    {(userGamesData !== null && userGamesData !== undefined && userGamesData.length > 0 && gameData !== null && gameData !== undefined) &&
                        userGamesData
                        .filter(game =>
                            game.gameId !== gameData.gameId
                        )
                        .map((game) => (
                            <GameBox
                                key={game.gameId}
                                game={game}
                                handleBoxClick={handleBoxClick}
                            />
                    ))}
                    {(userGamesData !== null && userGamesData !== undefined && userGamesData.length > 0) &&
                        missingTypes.map(type =>(
                            <EmptyGameBox
                                key={type}
                                gameType={type}
                                handleEmptyClick={handleEmptyClick}
                            />
                    ))}
                </div>
            </div>
            <div className="footer-container">
                <div className="footer-group" style={{display:"flex", flex:"1", flexDirection:"row"}}>
                    <img 
                        src="/assets/navbar/littlelot_logo_white.png"
                        style={{width:"100px", objectFit: "contain", margin:"10px"}}
                    />

                    <img 
                        src="/assets/navbar/gametory_glow_crop.png"
                        style={{width:"100px", objectFit: "contain", margin:"10px"}}
                    />
                </div>

                <div className="footer-group" style={{flex:"1", color:"white"}}>
                    <div className="footer-link" onClick={()=>handlePopupClick("https://www.gametory.com")}>HOME</div>
                    <div className="footer-link" onClick={()=>handleBackClick()}>GAMEROOM</div>
                    <div className="footer-link"onClick={()=>handlePopupClick("https://www.littlelot.toys")}>ABOUT LITTLE LOT</div>
                </div>

                <div className="footer-group-end" style={{display:"flex", flexDirection:"column", flex:"1"}}>
                    <div style={{display:"flex", flexDirection:"row"}}>
                        <img src="/assets/navbar/igicon.png" className="footer-link" onClick={()=>handlePopupClick("https://www.instagram.com/gametory.th")}/>
                        <img src="/assets/navbar/fbicon.png" className="footer-link" onClick={()=>handlePopupClick("https://www.facebook.com/gametory.th")}/>
                    </div>
                    <div className="footer-link" style={{textAlign:"end"}} onClick={()=>handleBookingClick()}>CONTACT US - LINE OFFICIAL ACCOUNT</div>
                    <div>V1.0.4-1</div>
                </div>
            </div>
        </div>
    );
};

export default GameInformative;
